<template>
    <section class="meeting-dayview" :loading="process.loading">
        <div class="header_row" style="height: 80px;">
            <div class="calendar-left" :style="{paddingBottom: 0, width: small?'5px':'179px'}" >
                <div class="calendar-district">
                    <div>
                        <el-input
                                style="width: auto"
                                size="medium"
                                v-model="target"
                                type="date"
                                @change="reload"
                                placeholder="选择日期">
                        </el-input>
                    </div>
                    <div class="mt-2 d-flex justify-content-between">
                        <el-button type="default" style="padding: 4px 25px;" size="medium"
                                   @click.native='previous' icon="el-icon-arrow-left">
                        </el-button>
                        <el-button type="default" style="padding: 4px 25px;" size="medium"
                                   icon="el-icon-arrow-right"
                                   @click.native='next'>

                        </el-button>
                    </div>
                </div>
            </div>

            <div class="calender-right" :style="{overflow:'hidden'}" ref="headerRule">
                <div class="wrapper" :style="{width:calendarWidth}">
                    <div class="rule">
                        <div class="relative">
                            <div class="calender-heading-trow" :style="{width:calendarWidth}">
                                <div class="cell" v-for="cell in ruleCells" :key="cell"
                                     :style="{width:cell_width + 'px'}">
                                    <div class="hour-text">{{cell}}
                                        <div class="minutes">
                                            <div><span>00</span></div>
                                            <div><span>30</span></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="clearfix"></div>
        <!-- body ----------------------------------------------------------------------------------------------->
        <div class="body-row-for-scroll" style="-webkit-overflow-scrolling: touch;" >
            <div class="body-row">
                <div class="calendar-left" :style="{paddingBottom: 0, width: small?'5px':'179px'}">
                    <div style="position: absolute;left: 0;right: 0;top: 0;bottom: 0;z-index: 99" @click="small=!small"></div>
                    <div id="meetingroom_room_list">
                        <div class="calender-trow-room" v-for="room in meetingRooms" :key="room.id">
                            <div class="name"> {{room.name}}
                                <div class="address">{{room.email}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- calendar -->
                <div class="calender-right" style="overflow: auto;" @scroll="syncHeader">
                    <div class="wrapper" :style="{width:calendarWidth}">
                        <div class="rule" id="meetingroom_scroll_area">
                            <div class="relative">
                                <!--  分会议室 制作表格 -->
                                <div style="position: relative;" class="calender-meeting">
                                    <div class="calender-body-trow"
                                         v-for="room in books" :key="room.id">
                                        <div class="cell" v-for="cell in ruleCells" :key="cell"
                                             :style="{width:cell_width + 'px'}">
                                            <div class="time-slot">
                                            </div>
                                        </div>
                                        <!-- Meeting List -->
                                        <div class="meeting"
                                             v-for="resv in room.reserves"
                                             :class="resv.approve === '1'?'submitted':'approved'"
                                             :key="resv.id"
                                             :style="{left:calcPosition(resv.meeting_date,resv.meeting_time,resv.duration).left,width:calcPosition(resv.meeting_date,resv.meeting_time,resv.duration).width}"
                                        >
                                            <el-popover placement="top" trigger="click">
                                                <div class="meeting-popover">
                                                    <div class="meeting-inner">
                                                        <div class="name text-info">({{resv.id}}){{resv.host_name}}
                                                        </div>
                                                        <div class="time mt-1">{{resv.meeting_time}} -
                                                            {{resv.meeting_end}}
                                                        </div>
                                                        <div class="department mt-1">{{resv.department}}</div>
                                                        <div class="author mt-1">{{resv.topic}}</div>
                                                        <div class="author mt-1">{{resv.meeting_id}}</div>
                                                        <div class="author mt-2 ">
                                                            {{resv.approve === '1'?'提交':'批准'}}
                                                            <span class="text-danger"> {{resv.option_h323 === '1'?'使用H.323':''}} </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="meeting-inner" slot="reference">
                                                    <div class="name">{{resv.host_name}}</div>
                                                    <div class="time">{{resv.meeting_time}} - {{resv.meeting_end}}</div>
                                                    <div class="department">{{resv.department}}</div>
                                                    <div class="author">{{resv.topic}}</div>
                                                    <div class="h323" v-if="resv.option_h323"><i
                                                            class="fa fa-circle"></i>
                                                    </div>
                                                </div>
                                            </el-popover>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clearfix"></div>
        </div>
    </section>

</template>

<script>

    import dayView from "../../common/mixins/meeting-dayview";

    export default {
        name: "meeting-dayview",
        mixins:[dayView],
        data(){return {
            small:1
        }}

    }
</script>

<style scoped lang="scss">
    @import "../../common/scss/dayview";
</style>
